<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" acceptLabel="SI" rejectLabel="NO"></p-confirmDialog>

<mat-grid-list cols="2"  rowHeight="4rem" >
    <mat-grid-tile>
      <div style="width: 100%;"  class="font-family">
        <button class="width-buttons" mat-flat-button color="accent" [disabled]="disableValidation" (click)="validar()">VALIDAR</button>
        <button class="width-buttons" mat-raised-button  (click)="limpiarData()">LIMPIAR</button>
      </div>
    </mat-grid-tile>
    <mat-grid-tile>
      <div style="width: 100%; justify-content: right; display: flex;"  class="font-family">
        <button class="width-buttons" mat-flat-button color="primary" [disabled]="disableSend"  (click)="crear()">ENVIAR</button>
      </div>
    </mat-grid-tile>
</mat-grid-list>
